<template>
  <BoxCard class="mb-10">
    <template #header>Invited Attendees</template>
    <template #content>
      <div v-if="this.invites.length > 0" class="my-1 border rounded-lg p-1">
        <table class="table-fixed w-full divide-y divide-gray-200">
          <tbody>
            <tr
              v-for="(invitedUser, index) in this.invites"
              :key="invitedUser.email"
              :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
              class="h-12"
            >
              <td class="px-3 py-1 text-left">
                <div class="font-medium text-gray-600 text-xxs md:text-xs break-words">
                  {{ invitedUser.email }}
                </div>
              </td>
              <td class="px-0 md:px-4 py-1 w-1/5 whitespace-nowrap">
                <span class="flex gap-1 justify-end" v-if="invitedUser.accepted_at">
                  <ViceBadge green small class="px-2.5 py-1">Accepted</ViceBadge>
                </span>
                <span class="flex gap-1 justify-end" v-else>
                  <ViceBadge yellow small class="px-2.5 py-1">Invitation sent</ViceBadge>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="prose prose-sm prose-vice" v-else>
        <span class="text-gray-500 italic">No invited users</span>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import BoxCard from '@/Components/Cards/BoxCard.vue';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';

export default {
  name: 'InvitedUsers',
  components: {
    ViceBadge,
    BoxCard,
  },
  data() {
    return {
      invites: this.$page.props.session.invites,
    };
  },
};
</script>

<style scoped></style>
